/* eslint-disable react/destructuring-assignment */

import TRANSLATIONS from '../translations/translations@default.json';

export const isAcceptedRegion = (regions) => {
	return regions?.indexOf(TRANSLATIONS.general.locale) > -1;
};

export const AcceptedRegions = (props) => {
	return isAcceptedRegion(Object.keys(props)) ? props.children : null;
};
